import { render, staticRenderFns } from "./manage-order.vue?vue&type=template&id=ad018bbe"
import script from "./manage-order.vue?vue&type=script&lang=ts"
export * from "./manage-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad018bbe')) {
      api.createRecord('ad018bbe', component.options)
    } else {
      api.reload('ad018bbe', component.options)
    }
    module.hot.accept("./manage-order.vue?vue&type=template&id=ad018bbe", function () {
      api.rerender('ad018bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/manage-order.vue"
export default component.exports